import React, {useContext,useEffect} from 'react'


import TemplateContext from '../../context/template/templateContext';
import TemplateItem  from './TemplateItem';

import TemplateForm  from './TemplateForm';



import {Row, Col, Button} from "react-bootstrap";

import '../../styles/images.scss';
import { useState } from 'react';

const Template = ({isAdmin}) => {


    // const authContext = useContext(AuthContext);

    const templateContext = useContext(TemplateContext);

    // const {isSuperAdmin} = authContext;
    const {getTemplates,templates, deleteTemplate} = templateContext;


    // const {members} = team || {};
     const [showForm,setShowForm] =  useState(false);



     const toggleForm= () =>{
        setShowForm(!showForm);
    }
    const closeForm = () =>{
        setShowForm(false);
    }
    const openForm= () =>{
        setShowForm(true);
    }

    useEffect(() =>{
         //authContext.loadUser();

        getTemplates();
    // eslint-disable-next-line
    },[])



  return (
        <>
            <Row className='pb-1 mb-5 border-bottom'>
                <div className='col-12 col-md-6'> 
                    <h1>Templates</h1>
                </div>
                <div className='mb-2 text-end d-flex align-items-end justify-content-end col-12 col-md-6'> 
                  { isAdmin && <Button onClick={openForm}>Add Template</Button> }
                </div>
            </Row>
  
            <Row>
                {showForm &&
                    <Col xs="12">  
                        <TemplateForm newTemplate={true} closeForm={closeForm}/>
                    </Col>
                }

                {templates !==null ? (<>
                    <Col xs="12">  
                    <Row className='border-bottom-bold fw-bold mt-4 py-2'>
                        <div className='col-12 col-md-4'>
                            Name
                        </div>

                        <div className='col-12 col-md-7'>
                            Subject / Body
                        </div>
                    </Row>
                </Col>
                       { templates.map(template => <TemplateItem key={template._id} template={template} deleteTemplate={deleteTemplate}/>)}
                    </>):
                    <div>No Templates</div>
                }

            </Row>

     
          
        </>
  )
}


export default Template;